import { useRouter } from 'next/router';
import React, { useContext, useEffect, useState, forwardRef} from 'react'
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Stack from "@mui/system/Stack";
import Button from '@mui/material/Button';
import { AlertContext } from '@/stores/alert-context'
import { AlertTypes, ActionType } from '@/helpers/constant/enum_data'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { actionText as TranslatedAction } from '@/helpers/constant/content_data';
import style from "./alert_snackbar.module.css"


const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="standard" {...props} />;
});

export default function AlertSnackbar() {
  const router = useRouter()
  const [state, dispatch] = useContext(AlertContext)
  const [open, setOpen] = useState(false)

  const [alertType, setAlertType] = useState(AlertTypes.NONE)
  const [actionType, setActionType] = useState(ActionType.CLOSE)
  const [actionText, setActionText] = useState(TranslatedAction.CLOSE)
  const [hideDuration, setHideDuration] = useState(null)
  const [message, setMessage] = useState('ขออภัย! เกิดข้อผิดพลาดขึ้น')
  const iconMappingList = {
    warning: <ErrorOutlineOutlinedIcon fontSize="inherit" />,
  }
  const snackbarPosition = {
    vertical: 'top',
    horizontal: 'center',
  }

  useEffect(() => {
    const { message, type, action } = state.alertShower
    setAlertType(type)
    setMessage(message)
    if (action) {
      const uppercaseAction = action?.toUpperCase()
      setActionType(ActionType?.[uppercaseAction])
      setActionText(TranslatedAction?.[uppercaseAction])
      if(type == "success") setHideDuration(10000)
    }
    if (type !== AlertTypes.NONE) setOpen(true)
  }, [state.alertShower])

  useEffect(() => {
    setOpen(false)
  }, [router])

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;

    setOpen(false)
  }

  const handleClick = (action = 'close') => {
    setOpen(false)
    if(action == 'refresh') router.reload()
  }

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar
        open={open}
        onClose={handleClose}
        autoHideDuration={hideDuration}
        className={style.snackbar}
        anchorOrigin={snackbarPosition}
      >
        {actionType == 'close' ? (
          <Alert
            severity={alertType}
            sx={{ width: '100%' }}
            iconMapping = {iconMappingList}
            onClose={handleClick}
          >
            <p>{message}</p>
          </Alert>
        ) : (
          <Alert
            severity={alertType}
            sx={{ width: '100%' }}
            iconMapping = {iconMappingList}
            action={
              <Button
                size="small"
                color="inherit"
                onClick={() => {
                  handleClick(
                    actionType == "confirm"
                      ? 'close'
                      : actionType
                  )
                }}
              >
                {actionText}
              </Button>
            }
          >
            <p>{message}</p>
          </Alert>
        )}
      </Snackbar>
    </Stack>
  )
}
